export default "https://assets.pclncdn.com/web/next-landing/7389f49ac8/_next/static/images/los-angeles-b282d194ac90b44a01abab53b00529de.webp";